import axiosInstance from "../../../api/axiosConfig";

export const getStockProducts = (params: any) => {
  return axiosInstance.get("/admin/stock-products", {
    params: params,
  });
};

export const deleteStockProduct = (id: string) => {
  return axiosInstance.delete(`/admin/stock-products/${id}`);
};

export const downloadSample = () => {
  return axiosInstance.post("/admin/stock-products/download-sample");
};

export const importStockProducts = (data: any) => {
  return axiosInstance.post("/admin/stock-products/import", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteImages = () => {
  return axiosInstance.post("/admin/stock-products/delete-images");
};

export const checkImageExist = () => {
  return axiosInstance.post("/admin/stock-products/check-image-exists");
};
